export const getEnvironmentVar = (code: string): string | undefined => {
  if (process && process.env && process.env[code]) return process.env[code];
  if (window && window._env_ && window._env_[code]) return window._env_[code];

  return '';
};
